import configureNotificationListeners from './notification/listeners'
import configureCheckoutListeners from './checkout/listeners'
import configureBidListeners from './bid/listeners'
import configureItemListeners from './item/listeners'
import configureAuctionListeners from './auction/listeners'
import configureSessionListeners from './session/listeners'
import myCharityListeners from './mycharity/listeners'

export const configureServices = ({ dispatch, getState }) => {
  const serviceListeners = [
    configureNotificationListeners,
    configureCheckoutListeners,
    configureBidListeners,
    configureItemListeners,
    configureAuctionListeners,
    configureSessionListeners,
    myCharityListeners
  ]
  serviceListeners.forEach(configure => configure(dispatch, getState))
}



// WEBPACK FOOTER //
// ./src/services/listeners.js